import React from 'react'
import { Grid, Typography, IconButton } from '@mui/material'
import { NavigateBefore, NavigateNext } from '@mui/icons-material'


const calculateUpperLimit = (count, limit, offset) => {
  if (count === 0) {
    return 0;
  }

  return Number(limit) > count ? Number(offset) + Number(count) - 1 : Number(offset) + Number(limit);
};

const Pagination = ({ count, limit = 50, offset = 0, paginateCallback, loading }) => {
  const upperLimit = calculateUpperLimit(count, limit, offset);

  return (
    <Grid container alignItems='center' gap={1}>
      <IconButton 
        sx={{ "&:hover": { color: "purple.scale100" }}}
        disabled={(Number(offset) === 0) || loading}  
        onClick={() => paginateCallback(Number(offset) - Number(limit))} 
      >
        <NavigateBefore />
      </IconButton>

      <Typography variant={'B400_14'} color={'purple.scale100'}>
        <b>{count === 0 ? 0 : offset + 1}</b> — <b>{upperLimit}</b>
        {count !== 0 && (
          <Typography pl={0.7} variant={'B400_14'} color={'grey.scale70'}>
            из {upperLimit} {(Number(offset) + Number(limit)) == upperLimit && (`+`)}
          </Typography>
        )}
      </Typography>

      <IconButton  
        sx={{ "&:hover": { color: "purple.scale100" }}}      
        disabled={(count === 0 || Number(limit) > count) || loading}
        onClick={() => paginateCallback(Number(offset) + Number(limit))} 
      >
        <NavigateNext />
      </IconButton>
    </Grid>
  )
}

export default Pagination;